import { faChartPie } from '@fortawesome/pro-regular-svg-icons/faChartPie';
import type { LinkOutContent, LinkOutFlag, LinkOutRoute } from './types';

const SEGMENTS_PATH = '/audiences/segments';

const SEGMENTS_FLAGS: LinkOutFlag[] = [
  'AGENT_STUDIO',
  'AGENT_STUDIO_AUDIENCES',
];

export const SEGMENTS_CONTENT: LinkOutContent = {
  title: 'Segments',
  heading: 'Manage segments in the new App',
  message: 'Segments have moved to the new Appcues App.',
  icon: faChartPie,
};

const routes: LinkOutRoute[] = [
  {
    // `/audience` and `/segments` already forward to the segment list inside
    // a sub-app; matching them here skips mounting it first.
    pattern: /^\/(segments|segments-v2|audience(?:\/segments(?:-v2)?)?)\/?$/i,
    resolve: () => SEGMENTS_PATH,
    content: SEGMENTS_CONTENT,
    flags: SEGMENTS_FLAGS,
    examples: ['/audience', '/audience/segments-v2', '/segments'],
  },
  {
    // Agent Studio's segment page is editable and enforces edit permission
    // itself, so view and edit share a route; `new` is its create page.
    pattern: /^\/segments(?:-v2)?\/([^/]+)\/(?:view|edit)\/?$/i,
    resolve: ([, id]) =>
      `${SEGMENTS_PATH}/${id.toLowerCase() === 'new' ? 'new' : id}`,
    content: SEGMENTS_CONTENT,
    flags: SEGMENTS_FLAGS,
    examples: ['/segments-v2/abc/view', '/segments/new/edit'],
  },
];

export default routes;
